import React from 'react';
import './unavailable.scss'; // 确保有对应的 SCSS 文件

const Unavailable = () => {
  return (
    <>
      <div className='warningContainer'>
        {/* <h1 className="warning_title">Service Not Available</h1> */}
        <h1 className="warning_title">We apologize, the store is not operating at this time.</h1>

        <p className="message">Please try again later.</p>

      </div>
    </>
  );
};

export default Unavailable;
